import React, {ReactNode} from 'react';
import { Modal } from 'antd';
import {Popup} from 'antd-mobile';

import cls from './MyModal.module.scss'

interface IMyModal {
    isOpen: boolean
    onClose:  () => void
    children: ReactNode
    className?: string
}

export const MyModal = ({
    isOpen,
    onClose,
    children,
    className,
}: IMyModal) => {
    const isSmallScreenWidth = window.innerWidth <= 425;

    if (isSmallScreenWidth) {
        return (
            <Popup visible={isOpen} onMaskClick={onClose} onClose={onClose} showCloseButton
                   bodyStyle={{borderTopLeftRadius: 8, borderTopRightRadius: 8}}>
                <div className={cls.content}>
                    {children}
                </div>
            </Popup>
        );
    }

    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            footer={null}
            className={className}
        >
            {children}
        </Modal>
    );
}
